module.exports = __webpack_public_path__ + "static/img/20240419_1.27a3aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240419_1.png
// module id = aGGh
// module chunks = 0